import GET_WEBSITE_DETAILS from '@/graphql/GET_WEBSITE_DETAILS.gql'
import GET_WEBSITE_SSO_URL from '@/graphql/GET_WEBSITE_SSO_URL.gql'
import GET_WEBSITE_PREVIEW_URL from '@/graphql/GET_WEBSITE_PREVIEW_URL.gql'
import GET_SCORECARD_SSO_URL from '@/graphql/GET_SCORECARD_SSO_URL.gql'
import GET_EMAIL_SSO_URL from '@/graphql/GET_EMAIL_SSO_URL.gql'
import GET_EMAIL_DETAILS from '@/graphql/GET_EMAIL_DETAILS.gql'
import GET_TOTALCHATBOT_SSO_URL from '@/graphql/GET_TOTALCHATBOT_SSO_URL.gql'
import { mapState, mapActions } from 'vuex'

const generatedUrlMixin = {
  computed: {
    ...mapState(['services'])
  },
  data () {
    return {
      errors: null
    }
  },
  apollo: {
    websiteDetails: {
      skip () {
        return Boolean(!this.services.website)
      },
      query: GET_WEBSITE_DETAILS,
      variables () {
        return { websiteId: this.services.website }
      },
      update: data => data.getWebsiteDetails,
      error (error) {
        this.errors = JSON.stringify(error.message)
      }
    },
    emailService: {
      skip () {
        return Boolean(!this.services.email)
      },
      query: GET_EMAIL_DETAILS,
      variables () {
        return { emailId: this.services.email }
      },
      update: data => data.getEmailDetails
    }
  },
  watch: {
    websiteDetails: {
      handler (newValue, oldValue) {
        if (newValue) {
          this.setWebsiteDetails(this.websiteDetails)
        }
      }
    }
  },
  methods: {
    ...mapActions('websiteService', ['setWebsiteDetails']),
    async goToGeneratedLink (linkFn, evt) {
      let newtab, link
      if (evt) {
        // If we include an event, grab the innertext
        // of the target to display 'loading' text
        const innerText = evt.target.innerText
        evt.target.innerText = 'Loading...'
        try {
          link = await linkFn()
          newtab = window.open()
          newtab.location = link
        } catch (err) {
          console.error(err)
        } finally {
          evt.target.innerText = innerText
        }
      } else {
        // If no event is included, open a new tab
        // immediately. Better when from the sidebar
        newtab = window.open()
        link = await linkFn()
        newtab.location = link
      }
    },

    async getEmailLink () {
      try {
        const { data } = await this.$apollo.query({
          query: GET_EMAIL_SSO_URL,
          variables: {
            emailId: this.services.email
          },
          fetchPolicy: 'network-only'
        })
        return data.getEmailSSOUrl
      } catch (err) {
        return err
      }
    },

    async getTotalChatBotLink() {
      try {
        const { data } = await this.$apollo.query({
            query: GET_TOTALCHATBOT_SSO_URL,
            variables: {
                totalChatbotsWebChatId: this.services.totalchatbotswebchat
            },
            fetchPolicy: 'network-only'
        })
        return data.totalChatbotsWebChatSsoUrlGet
      } catch (err) {
          return err
      }
    },

    async getWebsiteLink () {
      try {
        const { data } = await this.$apollo.query({
          query: GET_WEBSITE_SSO_URL,
          variables: {
            websiteId: this.services.website
          },
          fetchPolicy: 'network-only'
        })
        return data.getWebsiteSSOUrl
      } catch (err) {
        return err
      }
    },

    async getWebsitePreviewLink () {
      try {
        const { data } = await this.$apollo.query({
          query: GET_WEBSITE_PREVIEW_URL,
          variables: {
            websiteId: this.services.website
          },
          fetchPolicy: 'network-only'
        })
        return data.getWebsitePreviewUrl
      } catch (err) {
        return err
      }
    },

    async getScorecardLink () {
      try {
        const { data } = await this.$apollo.query({
          query: GET_SCORECARD_SSO_URL,
          variables: {
            scorecardId: this.services.scorecard
          },
          fetchPolicy: 'network-only'
        })
        return data.getScorecardSSOUrl
      } catch (err) {
        return err
      }
    },

    async getPPCLink () {
      try {
        const { data } = await this.$apollo.query({
          query: GET_SCORECARD_SSO_URL,
          variables: {
            scorecardId: this.services.payPerClick
          },
          fetchPolicy: 'network-only'
        })
        return data.getScorecardSSOUrl
      } catch (err) {
        return err
      }
    }
  }
}

export default generatedUrlMixin
